<h1 class="header">{{data.title}}</h1>
<div mat-dialog-content>
    <p>{{data.content}}</p>
</div>
<div class="justify-content-around" mat-dialog-actions>
    <button  class="btn btn-secondary" mat-button (click)="closeNo()">{{data.noButtonText}}</button>
    <button  class="btn btn-primary" mat-button cdkFocusInitial (click)="closeYes()">{{data.yesButtonText}}</button>
</div>